/**
 * The Flowers Directory — Checkout (v2)
 *
 * Two-step checkout:
 *   Step 1: Delivery details (recipient, address, date)
 *   Step 2: Your info + payment
 *
 * Features:
 *   - Auto zip-to-state lookup
 *   - Auto delivery date fetch on 5-digit zip
 *   - "Same as delivery" billing toggle (default ON)
 *   - Inline validation on blur
 *   - Delivery fee shown upfront ($19.99 flat)
 *   - Proper autocomplete attributes for browser autofill
 */
(function () {
  'use strict';

  var CONFIG = window.TFD_CONFIG || {};
  var API_BASE = CONFIG.apiBase || '';
  var DELIVERY_FEE = 19.99;

  // ============================================================
  // Zip-to-State Lookup (3-digit prefix → state code)
  // ============================================================

  var Z = {
    '005':'NY','006':'PR','007':'PR','008':'VI','009':'PR',
    '010':'MA','011':'MA','012':'MA','013':'MA','014':'MA','015':'MA','016':'MA','017':'MA','018':'MA','019':'MA',
    '020':'MA','021':'MA','022':'MA','023':'MA','024':'MA','025':'MA','026':'MA','027':'MA',
    '028':'RI','029':'RI',
    '030':'NH','031':'NH','032':'NH','033':'NH','034':'NH','035':'NH','036':'NH','037':'NH','038':'NH',
    '039':'ME','040':'ME','041':'ME','042':'ME','043':'ME','044':'ME','045':'ME','046':'ME','047':'ME','048':'ME','049':'ME',
    '050':'VT','051':'VT','052':'VT','053':'VT','054':'VT','055':'VT','056':'VT','057':'VT','058':'VT','059':'VT',
    '060':'CT','061':'CT','062':'CT','063':'CT','064':'CT','065':'CT','066':'CT','067':'CT','068':'CT','069':'CT',
    '070':'NJ','071':'NJ','072':'NJ','073':'NJ','074':'NJ','075':'NJ','076':'NJ','077':'NJ','078':'NJ','079':'NJ','080':'NJ','081':'NJ','082':'NJ','083':'NJ','084':'NJ','085':'NJ','086':'NJ','087':'NJ','088':'NJ','089':'NJ',
    '090':'AE','091':'AE','092':'AE','093':'AE','094':'AE','095':'AE','096':'AE','097':'AE','098':'AE','099':'AE',
    '100':'NY','101':'NY','102':'NY','103':'NY','104':'NY','105':'NY','106':'NY','107':'NY','108':'NY','109':'NY',
    '110':'NY','111':'NY','112':'NY','113':'NY','114':'NY','115':'NY','116':'NY','117':'NY','118':'NY','119':'NY',
    '120':'NY','121':'NY','122':'NY','123':'NY','124':'NY','125':'NY','126':'NY','127':'NY','128':'NY','129':'NY',
    '130':'NY','131':'NY','132':'NY','133':'NY','134':'NY','135':'NY','136':'NY','137':'NY','138':'NY','139':'NY','140':'NY','141':'NY','142':'NY','143':'NY','144':'NY','145':'NY','146':'NY','147':'NY','148':'NY','149':'NY',
    '150':'PA','151':'PA','152':'PA','153':'PA','154':'PA','155':'PA','156':'PA','157':'PA','158':'PA','159':'PA',
    '160':'PA','161':'PA','162':'PA','163':'PA','164':'PA','165':'PA','166':'PA','167':'PA','168':'PA','169':'PA',
    '170':'PA','171':'PA','172':'PA','173':'PA','174':'PA','175':'PA','176':'PA','177':'PA','178':'PA','179':'PA',
    '180':'PA','181':'PA','182':'PA','183':'PA','184':'PA','185':'PA','186':'PA','187':'PA','188':'PA','189':'PA','190':'PA','191':'PA','192':'PA','193':'PA','194':'PA','195':'PA','196':'PA',
    '197':'DE','198':'DE','199':'DE',
    '200':'DC','201':'VA','202':'DC','203':'DC','204':'DC','205':'DC',
    '206':'MD','207':'MD','208':'MD','209':'MD','210':'MD','211':'MD','212':'MD','214':'MD','215':'MD','216':'MD','217':'MD','218':'MD','219':'MD',
    '220':'VA','221':'VA','222':'VA','223':'VA','224':'VA','225':'VA','226':'VA','227':'VA','228':'VA','229':'VA',
    '230':'VA','231':'VA','232':'VA','233':'VA','234':'VA','235':'VA','236':'VA','237':'VA','238':'VA','239':'VA','240':'VA','241':'VA','242':'VA','243':'VA','244':'VA','245':'VA','246':'WV',
    '247':'WV','248':'WV','249':'WV','250':'WV','251':'WV','252':'WV','253':'WV','254':'WV','255':'WV','256':'WV','257':'WV','258':'WV','259':'WV','260':'WV','261':'WV','262':'WV','263':'WV','264':'WV','265':'WV','266':'WV','267':'WV','268':'WV',
    '270':'NC','271':'NC','272':'NC','273':'NC','274':'NC','275':'NC','276':'NC','277':'NC','278':'NC','279':'NC','280':'NC','281':'NC','282':'NC','283':'NC','284':'NC','285':'NC','286':'NC','287':'NC','288':'NC','289':'NC',
    '290':'SC','291':'SC','292':'SC','293':'SC','294':'SC','295':'SC','296':'SC','297':'SC','298':'SC','299':'SC',
    '300':'GA','301':'GA','302':'GA','303':'GA','304':'GA','305':'GA','306':'GA','307':'GA','308':'GA','309':'GA',
    '310':'GA','311':'GA','312':'GA','313':'GA','314':'GA','315':'GA','316':'GA','317':'GA','318':'GA','319':'GA',
    '320':'FL','321':'FL','322':'FL','323':'FL','324':'FL','325':'FL','326':'FL','327':'FL','328':'FL','329':'FL',
    '330':'FL','331':'FL','332':'FL','333':'FL','334':'FL','335':'FL','336':'FL','337':'FL','338':'FL','339':'FL',
    '340':'AA','341':'FL','342':'FL','344':'FL','346':'FL','347':'FL','349':'FL',
    '350':'AL','351':'AL','352':'AL','353':'AL','354':'AL','355':'AL','356':'AL','357':'AL','358':'AL','359':'AL',
    '360':'AL','361':'AL','362':'AL','363':'AL','364':'AL','365':'AL','366':'AL','367':'AL','368':'AL','369':'AL',
    '370':'TN','371':'TN','372':'TN','373':'TN','374':'TN','375':'TN','376':'TN','377':'TN','378':'TN','379':'TN',
    '380':'TN','381':'TN','382':'TN','383':'TN','384':'TN','385':'TN','386':'MS',
    '387':'MS','388':'MS','389':'MS','390':'MS','391':'MS','392':'MS','393':'MS','394':'MS','395':'MS','396':'MS','397':'MS',
    '398':'GA',
    '400':'KY','401':'KY','402':'KY','403':'KY','404':'KY','405':'KY','406':'KY','407':'KY','408':'KY','409':'KY',
    '410':'KY','411':'KY','412':'KY','413':'KY','414':'KY','415':'KY','416':'KY','417':'KY','418':'KY',
    '420':'KY','421':'KY','422':'KY','423':'KY','424':'KY','425':'KY','426':'KY','427':'KY',
    '430':'OH','431':'OH','432':'OH','433':'OH','434':'OH','435':'OH','436':'OH','437':'OH','438':'OH','439':'OH',
    '440':'OH','441':'OH','442':'OH','443':'OH','444':'OH','445':'OH','446':'OH','447':'OH','448':'OH','449':'OH',
    '450':'OH','451':'OH','452':'OH','453':'OH','454':'OH','455':'OH','456':'OH','457':'OH','458':'OH',
    '460':'IN','461':'IN','462':'IN','463':'IN','464':'IN','465':'IN','466':'IN','467':'IN','468':'IN','469':'IN',
    '470':'IN','471':'IN','472':'IN','473':'IN','474':'IN','475':'IN','476':'IN','477':'IN','478':'IN','479':'IN',
    '480':'MI','481':'MI','482':'MI','483':'MI','484':'MI','485':'MI','486':'MI','487':'MI','488':'MI','489':'MI',
    '490':'MI','491':'MI','492':'MI','493':'MI','494':'MI','495':'MI','496':'MI','497':'MI','498':'MI','499':'MI',
    '500':'IA','501':'IA','502':'IA','503':'IA','504':'IA','505':'IA','506':'IA','507':'IA','508':'IA','509':'IA',
    '510':'IA','511':'IA','512':'IA','513':'IA','514':'IA','515':'IA','516':'IA','520':'IA','521':'IA','522':'IA','523':'IA','524':'IA','525':'IA','526':'IA','527':'IA','528':'IA',
    '530':'WI','531':'WI','532':'WI','534':'WI','535':'WI','537':'WI','538':'WI','539':'WI',
    '540':'WI','541':'WI','542':'WI','543':'WI','544':'WI','545':'WI','546':'WI','547':'WI','548':'WI','549':'WI',
    '550':'MN','551':'MN','553':'MN','554':'MN','555':'MN','556':'MN','557':'MN','558':'MN','559':'MN',
    '560':'MN','561':'MN','562':'MN','563':'MN','564':'MN','565':'MN','566':'MN','567':'MN',
    '570':'SD','571':'SD','572':'SD','573':'SD','574':'SD','575':'SD','576':'SD','577':'SD',
    '580':'ND','581':'ND','582':'ND','583':'ND','584':'ND','585':'ND','586':'ND','587':'ND','588':'ND',
    '590':'MT','591':'MT','592':'MT','593':'MT','594':'MT','595':'MT','596':'MT','597':'MT','598':'MT','599':'MT',
    '600':'IL','601':'IL','602':'IL','603':'IL','604':'IL','605':'IL','606':'IL','607':'IL','608':'IL','609':'IL',
    '610':'IL','611':'IL','612':'IL','613':'IL','614':'IL','615':'IL','616':'IL','617':'IL','618':'IL','619':'IL',
    '620':'IL','622':'IL','623':'IL','624':'IL','625':'IL','626':'IL','627':'IL','628':'IL','629':'IL',
    '630':'MO','631':'MO','633':'MO','634':'MO','635':'MO','636':'MO','637':'MO','638':'MO','639':'MO',
    '640':'MO','641':'MO','644':'MO','645':'MO','646':'MO','647':'MO','648':'MO','649':'MO',
    '650':'MO','651':'MO','652':'MO','653':'MO','654':'MO','655':'MO','656':'MO','657':'MO','658':'MO',
    '660':'KS','661':'KS','662':'KS','664':'KS','665':'KS','666':'KS','667':'KS','668':'KS','669':'KS',
    '670':'KS','671':'KS','672':'KS','673':'KS','674':'KS','675':'KS','676':'KS','677':'KS','678':'KS','679':'KS',
    '680':'NE','681':'NE','683':'NE','684':'NE','685':'NE','686':'NE','687':'NE','688':'NE','689':'NE','690':'NE','691':'NE','692':'NE','693':'NE',
    '700':'LA','701':'LA','703':'LA','704':'LA','705':'LA','706':'LA','707':'LA','708':'LA','710':'LA','711':'LA','712':'LA','713':'LA','714':'LA',
    '716':'AR','717':'AR','718':'AR','719':'AR','720':'AR','721':'AR','722':'AR','723':'AR','724':'AR','725':'AR','726':'AR','727':'AR','728':'AR','729':'AR',
    '730':'OK','731':'OK','734':'OK','735':'OK','736':'OK','737':'OK','738':'OK','739':'OK',
    '740':'OK','741':'OK','743':'OK','744':'OK','745':'OK','746':'OK','747':'OK','748':'OK','749':'OK',
    '750':'TX','751':'TX','752':'TX','753':'TX','754':'TX','755':'TX','756':'TX','757':'TX','758':'TX','759':'TX',
    '760':'TX','761':'TX','762':'TX','763':'TX','764':'TX','765':'TX','766':'TX','767':'TX','768':'TX','769':'TX',
    '770':'TX','771':'TX','772':'TX','773':'TX','774':'TX','775':'TX','776':'TX','777':'TX','778':'TX','779':'TX',
    '780':'TX','781':'TX','782':'TX','783':'TX','784':'TX','785':'TX','786':'TX','787':'TX','788':'TX','789':'TX',
    '790':'TX','791':'TX','792':'TX','793':'TX','794':'TX','795':'TX','796':'TX','797':'TX','798':'TX','799':'TX',
    '800':'CO','801':'CO','802':'CO','803':'CO','804':'CO','805':'CO','806':'CO','807':'CO','808':'CO','809':'CO',
    '810':'CO','811':'CO','812':'CO','813':'CO','814':'CO','815':'CO','816':'CO',
    '820':'WY','821':'WY','822':'WY','823':'WY','824':'WY','825':'WY','826':'WY','827':'WY','828':'WY','829':'WY','830':'WY','831':'WY',
    '832':'ID','833':'ID','834':'ID','835':'ID','836':'ID','837':'ID','838':'ID',
    '840':'UT','841':'UT','842':'UT','843':'UT','844':'UT','845':'UT','846':'UT','847':'UT',
    '850':'AZ','851':'AZ','852':'AZ','853':'AZ','855':'AZ','856':'AZ','857':'AZ','859':'AZ','860':'AZ','863':'AZ','864':'AZ','865':'AZ',
    '870':'NM','871':'NM','872':'NM','873':'NM','874':'NM','875':'NM','877':'NM','878':'NM','879':'NM','880':'NM','881':'NM','882':'NM','883':'NM','884':'NM',
    '889':'NV','890':'NV','891':'NV','893':'NV','894':'NV','895':'NV','897':'NV','898':'NV',
    '900':'CA','901':'CA','902':'CA','903':'CA','904':'CA','905':'CA','906':'CA','907':'CA','908':'CA','910':'CA','911':'CA','912':'CA','913':'CA','914':'CA','915':'CA','916':'CA','917':'CA','918':'CA',
    '919':'CA','920':'CA','921':'CA','922':'CA','923':'CA','924':'CA','925':'CA','926':'CA','927':'CA','928':'CA',
    '930':'CA','931':'CA','932':'CA','933':'CA','934':'CA','935':'CA','936':'CA','937':'CA','938':'CA','939':'CA',
    '940':'CA','941':'CA','942':'CA','943':'CA','944':'CA','945':'CA','946':'CA','947':'CA','948':'CA','949':'CA',
    '950':'CA','951':'CA','952':'CA','953':'CA','954':'CA','955':'CA','956':'CA','957':'CA','958':'CA','959':'CA',
    '960':'CA','961':'CA',
    '967':'HI','968':'HI',
    '970':'OR','971':'OR','972':'OR','973':'OR','974':'OR','975':'OR','976':'OR','977':'OR','978':'OR','979':'OR',
    '980':'WA','981':'WA','982':'WA','983':'WA','984':'WA','985':'WA','986':'WA','988':'WA','989':'WA','990':'WA','991':'WA','992':'WA','993':'WA','994':'WA',
    '995':'AK','996':'AK','997':'AK','998':'AK','999':'AK'
  };

  function stateFromZip(zip) {
    if (!zip || zip.length < 3) return '';
    return Z[zip.substring(0, 3)] || '';
  }

  // ============================================================
  // US States list
  // ============================================================

  var US_STATES = [
    'AL','AK','AZ','AR','CA','CO','CT','DE','DC','FL',
    'GA','HI','ID','IL','IN','IA','KS','KY','LA','ME',
    'MD','MA','MI','MN','MS','MO','MT','NE','NV','NH',
    'NJ','NM','NY','NC','ND','OH','OK','OR','PA','RI',
    'SC','SD','TN','TX','UT','VT','VA','WA','WV','WI','WY',
  ];

  // ============================================================
  // State
  // ============================================================

  var state = {
    cartSessionId: null,
    cartItems: [],
    productImages: {},
    authorizenet: null,
    deliveryDates: [],
    orderTotal: null,
    quoteKey: '',
    quoteRequest: 0,
    quotePromise: null,
    quoteLoading: false,
    datesRequest: 0,
    currentStep: 1,
    datesFetched: false,
    datesLoading: false,
    prefill: null,
  };

  var $root;

  try {
    state.cartSessionId = localStorage.getItem('tfd_cart_session') || null;
    state.productImages = JSON.parse(localStorage.getItem('tfd_product_images') || '{}');
  } catch (e) {}

  // Capture session-entry attribution once per tab session (no-op if tfd-cart.js already set it).
  try {
    if (!sessionStorage.getItem('tfd_entry')) {
      var ref = document.referrer || '(direct)';
      var p = new URLSearchParams(window.location.search);
      var utm = ['utm_source','utm_medium','utm_campaign','utm_term','utm_content','q','query','search','gclid','fbclid','msclkid']
        .map(function(k){ var v = p.get(k); return v ? k+'='+v : null; })
        .filter(Boolean).join('&');
      sessionStorage.setItem('tfd_entry', utm ? ref + ' | ' + utm : ref);
      sessionStorage.setItem('tfd_landing', window.location.pathname + window.location.search);
    }
  } catch (e) {}

  // Funnel events -> tfd-cro /api/tfd-funnel (same helpers as tfd-cart.js). Checkout
  // events are sent for every visit; the landing URL carries the ad keyword when there is one.
  function visitId() {
    try {
      var v = sessionStorage.getItem('tfd_vid');
      if (!v) { v = Date.now().toString(36) + Math.random().toString(36).slice(2, 8); sessionStorage.setItem('tfd_vid', v); }
      return v;
    } catch (e) { return ''; }
  }
  function trackFunnel(type, data) {
    try {
      var payload = { t: type, sid: visitId(), page: location.pathname + location.search,
        landing: sessionStorage.getItem('tfd_landing') || '', entry: sessionStorage.getItem('tfd_entry') || '' };
      for (var k in (data || {})) payload[k] = data[k];
      var body = JSON.stringify(payload);
      if (navigator.sendBeacon && navigator.sendBeacon('/api/tfd-funnel', body)) return;
      fetch('/api/tfd-funnel', { method: 'POST', body: body, keepalive: true }).catch(function () {});
    } catch (e) {}
  }
  function cartInfo(extra) {
    var items = state.cartItems || [];
    var info = { codes: items.map(function (i) { return i.CODE; }).join(','),
                 value: items.reduce(function (sum, i) { return sum + (Number(i.PRICE) || 0); }, 0) };
    for (var k in (extra || {})) info[k] = extra[k];
    return info;
  }

  // ============================================================
  // API
  // ============================================================

  function apiFetch(path, options) {
    options = options || {};
    var url = API_BASE + path;
    var qs = [];
    if (options.params) {
      Object.keys(options.params).forEach(function (k) {
        var v = options.params[k];
        if (v != null) qs.push(encodeURIComponent(k) + '=' + encodeURIComponent(v));
      });
    }
    if (qs.length) url += '?' + qs.join('&');
    var headers = options.headers || {};
    headers['X-TFD-Referrer'] = window.location.pathname;
    try {
      var entry = sessionStorage.getItem('tfd_entry');
      var landing = sessionStorage.getItem('tfd_landing');
      if (entry) headers['X-TFD-Entry'] = entry;
      if (landing) headers['X-TFD-Landing'] = landing;
    } catch (e) {}

    return fetch(url, {
      method: options.method || 'GET',
      headers: headers,
      body: options.body,
      signal: options.signal,
    }).then(function (resp) {
      return resp.json().then(function (data) {
        if (!resp.ok) throw new Error("Could not complete the request. Please try again.");
        if (data.errors && data.errors.length) throw new Error(data.errors.join(', '));
        return data;
      });
    });
  }

  // ============================================================
  // Helpers
  // ============================================================

  function $(sel) { return document.querySelector(sel); }
  function $$(sel) { return document.querySelectorAll(sel); }
  function val(sel) { var el = $(sel); return el ? el.value.trim() : ''; }
  function esc(s) { var d = document.createElement('div'); d.textContent = s || ''; return d.innerHTML; }

  function formatDate(dateStr) {
    var parts = dateStr.split('/');
    var d = new Date(parseInt(parts[2]), parseInt(parts[0]) - 1, parseInt(parts[1]));
    return d.toLocaleDateString('en-US', { weekday: 'short', month: 'long', day: 'numeric' });
  }

  function toApiDate(dateStr) {
    var p = dateStr.split('/');
    return p[2] + '-' + p[0] + '-' + p[1];
  }

  // ============================================================
  // Inline Validation
  // ============================================================

  function validateField(el) {
    var val = el.value.trim();
    var group = el.closest('.tfd-form-group');
    if (!group) return !!val;

    var hint = group.querySelector('.tfd-field-hint');
    var isRequired = el.hasAttribute('required');

    if (isRequired && !val) {
      el.classList.add('tfd-invalid');
      el.classList.remove('tfd-valid');
      if (hint) hint.textContent = 'Required';
      if (hint) hint.style.display = '';
      return false;
    }

    if (el.type === 'email' && val && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val)) {
      el.classList.add('tfd-invalid');
      el.classList.remove('tfd-valid');
      if (hint) hint.textContent = 'Enter a valid email';
      if (hint) hint.style.display = '';
      return false;
    }

    el.classList.remove('tfd-invalid');
    if (val) el.classList.add('tfd-valid');
    if (hint) hint.style.display = 'none';
    return true;
  }

  function attachValidation() {
    $$('#tfd-checkout input[required], #tfd-checkout select[required], #tfd-checkout textarea[required]').forEach(function (el) {
      el.addEventListener('blur', function () { validateField(el); });
    });
  }

  function validateStep(step) {
    var container = $('#tfd-step-' + step);
    if (!container) return true;
    var fields = container.querySelectorAll('input[required], select[required]');
    var valid = true;
    fields.forEach(function (el) {
      if (!validateField(el)) valid = false;
    });
    return valid;
  }

  // ============================================================
  // Render
  // ============================================================

  function renderCheckout() {
    var items = state.cartItems;
    if (!items.length) {
      $root.innerHTML =
        '<div style="text-align:center;padding:3em 1em">' +
          '<h2>Your cart is empty</h2>' +
          '<p style="color:#666">Add some flowers before checking out.</p>' +
          '<a href="/" class="tfd-btn tfd-btn-primary" style="display:inline-block;margin-top:1em;text-decoration:none">Continue Shopping</a>' +
        '</div>';
      return;
    }

    var stateOpts = US_STATES.map(function (s) { return '<option value="' + s + '">' + s + '</option>'; }).join('');
    var yr = new Date().getFullYear();
    var yearOpts = ''; for (var y = yr; y < yr + 10; y++) yearOpts += '<option value="' + y + '">' + y + '</option>';
    var monthOpts = ''; for (var m = 1; m <= 12; m++) { var mm = (m < 10 ? '0' : '') + m; monthOpts += '<option value="' + mm + '">' + mm + '</option>'; }

    var subtotal = items.reduce(function (s, p) { return s + p.PRICE; }, 0);

    var orderItemsHTML = items.map(function (p) {
      var img = state.productImages[p.CODE] || '';
      return '<div class="tfd-order-item">' +
        (img ? '<img src="' + esc(img) + '" style="width:40px;height:40px;object-fit:cover;border-radius:4px;margin-right:0.75em">' : '') +
        '<span style="flex:1">' + esc(p.NAME) + '</span>' +
        '<span>$' + p.PRICE.toFixed(2) + '</span>' +
      '</div>';
    }).join('');

    // Build validation hint helper
    function hint() { return '<div class="tfd-field-hint" style="display:none"></div>'; }

    $root.innerHTML =
      // Inject checkout-specific CSS
      '<style>' +
        '.tfd-steps{display:flex;align-items:center;gap:0;margin-bottom:1.5em;padding:0;}' +
        '.tfd-step-dot{width:32px;height:32px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:0.85em;font-weight:700;border:2px solid var(--tfd-border);color:var(--tfd-text-muted);background:#fff;flex-shrink:0;transition:all 0.3s;}' +
        '.tfd-step-dot.active{border-color:var(--tfd-primary);background:var(--tfd-primary);color:#fff;}' +
        '.tfd-step-dot.done{border-color:var(--tfd-success);background:var(--tfd-success);color:#fff;}' +
        '.tfd-step-line{flex:1;height:2px;background:var(--tfd-border);transition:background 0.3s;}' +
        '.tfd-step-line.done{background:var(--tfd-success);}' +
        '.tfd-step-label{font-size:0.8em;color:var(--tfd-text-muted);margin-top:0.3em;text-align:center;}' +
        '.tfd-step-label.active{color:var(--tfd-primary);font-weight:600;}' +
        '.tfd-step-label.done{color:var(--tfd-success);}' +
        '.tfd-step-group{display:flex;flex-direction:column;align-items:center;}' +
        '.tfd-checkout-step{display:none;animation:tfd-fadeIn 0.25s;}' +
        '.tfd-checkout-step.active{display:block;}' +
        '.tfd-invalid{border-color:#c0392b !important;}' +
        '.tfd-valid{border-color:var(--tfd-success) !important;}' +
        '.tfd-field-hint{font-size:0.8em;color:#c0392b;margin-top:0.2em;}' +
        '.tfd-same-addr{display:flex;align-items:center;gap:0.6em;padding:0.8em 0;cursor:pointer;font-size:0.95em;user-select:none;}' +
        '.tfd-same-addr input{width:18px;height:18px;accent-color:var(--tfd-primary);}' +
        '.tfd-billing-fields{overflow:hidden;transition:max-height 0.3s,opacity 0.3s;max-height:0;opacity:0;}' +
        '.tfd-billing-fields.show{max-height:500px;opacity:1;}' +
        '.tfd-trust-badge{display:flex;align-items:center;gap:0.5em;padding:0.8em 1em;background:#f8f9fa;border:1px solid var(--tfd-border);border-radius:var(--tfd-radius);margin-top:0.75em;font-size:0.85em;color:var(--tfd-text-muted);}' +
        '.tfd-trust-badge svg{width:16px;height:16px;fill:var(--tfd-success);flex-shrink:0;}' +
        '.tfd-btn-row{display:flex;gap:0.75em;margin-top:0.5em;}' +
        '.tfd-btn-row .tfd-btn{flex:1;}' +
        '.tfd-date-loading{display:inline-flex;align-items:center;gap:0.5em;font-size:0.9em;color:var(--tfd-text-muted);padding:0.6em 0;}' +
        '.tfd-date-loading .tfd-spinner{width:18px;height:18px;border-width:2px;}' +
        '.tfd-form-row-3{display:grid;grid-template-columns:1fr auto auto;gap:0.75em;}' +
        '@media(max-width:768px){.tfd-form-row-3{grid-template-columns:1fr;}}' +
      '</style>' +

      '<a href="/" style="color:#666;font-size:0.9em;text-decoration:none">&larr; Continue shopping</a>' +
      '<h1 style="font-size:1.5em;margin:0.5em 0 1em">Checkout</h1>' +

      // Progress indicator
      '<div class="tfd-steps">' +
        '<div class="tfd-step-group"><div class="tfd-step-dot active" id="dot-1">1</div><div class="tfd-step-label active" id="label-1">Delivery</div></div>' +
        '<div class="tfd-step-line" id="step-line"></div>' +
        '<div class="tfd-step-group"><div class="tfd-step-dot" id="dot-2">2</div><div class="tfd-step-label" id="label-2">Payment</div></div>' +
      '</div>' +

      '<div id="tfd-checkout-error"></div>' +

      // ==================== STEP 1: Delivery ====================
      '<div class="tfd-checkout-step active" id="tfd-step-1">' +

        '<div class="tfd-section"><h3>Who\'s receiving the flowers?</h3>' +
          '<div class="tfd-form-row">' +
            '<div class="tfd-form-group"><label>Recipient Name *</label><input type="text" id="r-name" required autocomplete="shipping name">' + hint() + '</div>' +
            '<div class="tfd-form-group"><label>Phone *</label><input type="tel" id="r-phone" required autocomplete="shipping tel">' + hint() + '</div>' +
          '</div>' +
          // Sent as recipient.institution / recipient.address2 (Sep 2026). Before this, 0 of 65
          // orders carried either, so florists never saw the funeral home, hospital or room.
          '<div class="tfd-form-group"><label>Funeral Home, Hospital or Business <span style="color:var(--tfd-text-muted);font-weight:400">(optional)</span></label><input type="text" id="r-inst" maxlength="60" autocomplete="shipping organization" placeholder="e.g. Smith Funeral Home, St. Mary\'s Hospital"></div>' +
          '<div class="tfd-form-group"><label>Delivery Address *</label><input type="text" id="r-addr" required autocomplete="shipping address-line1">' + hint() + '</div>' +
          '<div class="tfd-form-group"><label>Apt, Suite, Floor or Room <span style="color:var(--tfd-text-muted);font-weight:400">(optional)</span></label><input type="text" id="r-addr2" maxlength="40" autocomplete="shipping address-line2" placeholder="e.g. Apt 4B, Room 312"></div>' +
          '<div class="tfd-form-row-3">' +
            '<div class="tfd-form-group"><label>City *</label><input type="text" id="r-city" required autocomplete="shipping address-level2">' + hint() + '</div>' +
            '<div class="tfd-form-group"><label>State *</label><select id="r-state" required autocomplete="shipping address-level1"><option value="">--</option>' + stateOpts + '</select>' + hint() + '</div>' +
            '<div class="tfd-form-group"><label>Zip *</label><input type="text" id="r-zip" required maxlength="5" inputmode="numeric" pattern="[0-9]*" autocomplete="shipping postal-code" style="width:5.5em">' + hint() + '</div>' +
          '</div>' +
          '<div id="dates-area">' +
            '<div class="tfd-form-group"><label>Delivery Date *</label>' +
              '<div id="dates-content"><select id="r-date" required disabled><option value="">Enter zip code above</option></select></div>' +
            hint() + '</div>' +
          '</div>' +
          '<div class="tfd-form-group"><label>Card Message <span style="color:var(--tfd-text-muted);font-weight:400">(optional, 200 chars)</span></label><textarea id="r-message" maxlength="200" rows="2" autocomplete="off"></textarea></div>' +
          '<div class="tfd-form-group"><label>Special Instructions <span style="color:var(--tfd-text-muted);font-weight:400">(optional, 100 chars)</span></label><textarea id="r-instr" maxlength="100" rows="2" autocomplete="off"></textarea></div>' +
        '</div>' +

        // Order Summary (always visible)
        '<div class="tfd-section"><h3>Order Summary</h3>' +
          '<div class="tfd-order-items">' + orderItemsHTML + '</div>' +
          '<div id="order-totals" aria-live="polite" aria-atomic="true">' +
            '<div class="tfd-order-line"><span>Subtotal</span><span>$' + subtotal.toFixed(2) + '</span></div>' +
            '<div class="tfd-order-line"><span>Delivery</span><span>$' + DELIVERY_FEE.toFixed(2) + '</span></div>' +
            '<div class="tfd-order-line"><span>Tax</span><span id="tax-display">Enter delivery ZIP</span></div>' +
            '<div class="tfd-order-total"><span>Total</span><span id="total-display">Enter delivery ZIP</span></div>' +
          '</div>' +
        '</div>' +

        '<button class="tfd-btn tfd-btn-primary" id="continue-btn" disabled style="width:100%;padding:1em;font-size:1.1em">Continue to Payment &rarr;</button>' +

      '</div>' +

      // ==================== STEP 2: Payment ====================
      '<div class="tfd-checkout-step" id="tfd-step-2">' +

        '<div class="tfd-section"><h3>Your Information</h3>' +
          '<label class="tfd-same-addr"><input type="checkbox" id="same-addr" checked> Same address as delivery</label>' +
          '<div class="tfd-form-row">' +
            '<div class="tfd-form-group"><label>Full Name *</label><input type="text" id="c-name" required autocomplete="name">' + hint() + '</div>' +
            '<div class="tfd-form-group"><label>Email *</label><input type="email" id="c-email" required autocomplete="email">' + hint() + '</div>' +
          '</div>' +
          '<div class="tfd-form-group"><label>Phone *</label><input type="tel" id="c-phone" required autocomplete="tel">' + hint() + '</div>' +
          '<div class="tfd-billing-fields" id="billing-fields">' +
            '<div class="tfd-form-group"><label>Billing Address *</label><input type="text" id="c-addr" autocomplete="billing street-address">' + hint() + '</div>' +
            '<div class="tfd-form-row-3">' +
              '<div class="tfd-form-group"><label>City *</label><input type="text" id="c-city" autocomplete="billing address-level2">' + hint() + '</div>' +
              '<div class="tfd-form-group"><label>State *</label><select id="c-state" autocomplete="billing address-level1"><option value="">--</option>' + stateOpts + '</select>' + hint() + '</div>' +
              '<div class="tfd-form-group"><label>Zip *</label><input type="text" id="c-zip" maxlength="5" inputmode="numeric" pattern="[0-9]*" autocomplete="billing postal-code" style="width:5.5em">' + hint() + '</div>' +
            '</div>' +
          '</div>' +
        '</div>' +

        '<div class="tfd-section"><h3>Payment</h3>' +
          '<div class="tfd-form-group"><label>Card Number *</label><input type="text" id="cc-num" required maxlength="19" placeholder="4242 4242 4242 4242" inputmode="numeric" autocomplete="cc-number">' + hint() + '</div>' +
          '<div class="tfd-form-row">' +
            '<div class="tfd-form-group"><label>Expiration *</label>' +
              '<div style="display:flex;gap:0.5em"><select id="cc-month" required autocomplete="cc-exp-month"><option value="">MM</option>' + monthOpts + '</select>' +
              '<select id="cc-year" required autocomplete="cc-exp-year"><option value="">YYYY</option>' + yearOpts + '</select></div>' +
            hint() + '</div>' +
            '<div class="tfd-form-group"><label>CVV *</label><input type="text" id="cc-cvv" required maxlength="4" inputmode="numeric" autocomplete="cc-csc">' + hint() + '</div>' +
          '</div>' +
          '<div class="tfd-trust-badge">' +
            '<svg viewBox="0 0 24 24"><path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"/></svg>' +
            'Secure payment processed by Authorize.net. Your card details never touch our servers.' +
          '</div>' +
        '</div>' +

        // Order Summary (repeated on step 2)
        '<div class="tfd-section"><h3>Order Summary</h3>' +
          '<div class="tfd-order-items">' + orderItemsHTML + '</div>' +
          '<div id="order-totals-2" aria-live="polite" aria-atomic="true">' +
            '<div class="tfd-order-line"><span>Subtotal</span><span>$' + subtotal.toFixed(2) + '</span></div>' +
            '<div class="tfd-order-line"><span>Delivery</span><span>$' + DELIVERY_FEE.toFixed(2) + '</span></div>' +
            '<div class="tfd-order-line"><span>Tax</span><span id="tax-display-2">Enter delivery ZIP</span></div>' +
            '<div class="tfd-order-total"><span>Total</span><span id="total-display-2">Enter delivery ZIP</span></div>' +
          '</div>' +
        '</div>' +

        '<div class="tfd-btn-row">' +
          '<button class="tfd-btn tfd-btn-secondary" id="back-btn">&larr; Back</button>' +
          '<button class="tfd-btn tfd-btn-primary" id="place-order-btn" disabled style="padding:1em;font-size:1.05em">Place Order</button>' +
        '</div>' +

      '</div>';

    // ==================== Event Handlers ====================

    // Step navigation
    $('#continue-btn').addEventListener('click', goToStep2);
    $('#back-btn').addEventListener('click', goToStep1);
    $('#place-order-btn').addEventListener('click', placeOrder);

    // Same-as-delivery toggle
    $('#same-addr').addEventListener('change', function () {
      var fields = $('#billing-fields');
      if (this.checked) {
        fields.classList.remove('show');
        // Remove required from hidden billing fields
        setBillingRequired(false);
      } else {
        fields.classList.add('show');
        setBillingRequired(true);
      }
    });

    // Every ZIP change invalidates its quote and dates before another request starts.
    $('#r-zip').addEventListener('input', function () {
      var zip = this.value.replace(/\D/g, '').slice(0, 5);
      this.value = zip;
      invalidateQuote(/^\d{5}$/.test(zip) ? 'Calculating…' : 'Enter delivery ZIP');
      state.datesRequest++;
      state.deliveryDates = [];
      state.datesFetched = false;
      state.datesLoading = false;
      $('#dates-content').innerHTML = '<select id="r-date" required disabled><option value="">Enter delivery ZIP code above</option></select>';
      if (zip.length >= 3) {
        var st = stateFromZip(zip);
        if (st) $('#r-state').value = st;
      }
      if (zip.length === 5) {
        autoFetchDates(zip);
        calcTotal();
      }
    });

    // Auto zip-to-state for billing
    var cZip = $('#c-zip');
    if (cZip) {
      cZip.addEventListener('input', function () {
        var zip = this.value.replace(/\D/g, '');
        this.value = zip;
        if (zip.length >= 3) {
          var st = stateFromZip(zip);
          if (st) $('#c-state').value = st;
        }
      });
    }

    // Date change → recalc total
    $('#r-date').addEventListener('change', function () {
      if (this.value) calcTotal();
    });

    // Attach inline validation
    attachValidation();

    // A prefilled link's ZIP goes in first, so an older saved ZIP never replaces it.
    if (state.prefill) applyPrefill(state.prefill);

    // A ZIP already checked on a product page can provide an exact total immediately.
    try {
      var savedZip = localStorage.getItem('tfd_delivery_zip') || '';
      if (!val('#r-zip') && /^\d{5}$/.test(savedZip)) {
        $('#r-zip').value = savedZip;
        var savedState = stateFromZip(savedZip);
        if (savedState) $('#r-state').value = savedState;
        autoFetchDates(savedZip);
        calcTotal();
      }
    } catch (e) {}
  }

  function setBillingRequired(req) {
    ['#c-addr', '#c-city', '#c-state', '#c-zip'].forEach(function (sel) {
      var el = $(sel);
      if (el) {
        if (req) { el.setAttribute('required', ''); }
        else { el.removeAttribute('required'); el.classList.remove('tfd-invalid'); }
      }
    });
  }

  // ============================================================
  // Step Navigation
  // ============================================================

  async function goToStep2() {
    clearError();

    // Validate step 1
    if (!validateStep(1)) {
      showError('Please fill in all required delivery fields.');
      return;
    }

    // Must have a delivery date selected
    if (!val('#r-date')) {
      showError('Please select a delivery date. Enter the delivery zip code to see available dates.');
      var dateEl = $('#r-date');
      if (dateEl) { dateEl.classList.add('tfd-invalid'); }
      return;
    }

    if (!await calcTotal()) {
      showError('Please confirm the delivery ZIP so we can calculate your total.');
      return;
    }

    state.currentStep = 2;
    $('#tfd-step-1').classList.remove('active');
    $('#tfd-step-2').classList.add('active');

    // Update progress dots
    $('#dot-1').classList.remove('active');
    $('#dot-1').classList.add('done');
    $('#dot-1').innerHTML = '&#10003;';
    $('#label-1').classList.remove('active');
    $('#label-1').classList.add('done');
    $('#dot-2').classList.add('active');
    $('#label-2').classList.add('active');
    $('#step-line').classList.add('done');

    // Re-attach validation for step 2 fields
    attachValidation();

    // Scroll to top
    $root.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function goToStep1() {
    clearError();
    state.currentStep = 1;
    $('#tfd-step-2').classList.remove('active');
    $('#tfd-step-1').classList.add('active');

    // Update progress dots
    $('#dot-1').classList.add('active');
    $('#dot-1').classList.remove('done');
    $('#dot-1').innerHTML = '1';
    $('#label-1').classList.add('active');
    $('#label-1').classList.remove('done');
    $('#dot-2').classList.remove('active');
    $('#label-2').classList.remove('active');
    $('#step-line').classList.remove('done');

    $root.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  // ============================================================
  // Auto-fetch delivery dates
  // ============================================================

  // preferredDate (YYYY-MM-DD) is selected when offered, e.g. a date saved by
  // an AI assistant's prefilled checkout link.
  function autoFetchDates(zip, preferredDate) {
    var requestId = ++state.datesRequest;
    state.datesLoading = true;
    var container = $('#dates-content');
    container.innerHTML = '<div class="tfd-date-loading"><div class="tfd-spinner"></div> Checking delivery dates...</div>';
    return apiFetch('/delivery-dates', { params: { zipcode: zip } }).then(function (data) {
      if (requestId !== state.datesRequest || val('#r-zip') !== zip) return;
      state.deliveryDates = Array.isArray(data.DATES) ? data.DATES.filter(function (date) {
        return typeof date === 'string' && /^\d{1,2}\/\d{1,2}\/\d{4}$/.test(date);
      }) : [];
      state.datesLoading = false;
      if (!state.deliveryDates.length) {
        container.innerHTML = '<p style="color:#c0392b;font-size:0.9em;margin:0.4em 0">No delivery dates available for this ZIP code. Please try a different ZIP.</p>' +
          '<select id="r-date" required disabled><option value="">No dates available</option></select>';
        return;
      }
      state.datesFetched = true;
      container.innerHTML = '<select id="r-date" required><option value="">Select delivery date...</option>' +
        state.deliveryDates.map(function (d) {
          return '<option value="' + toApiDate(d) + '">' + formatDate(d) + '</option>';
        }).join('') + '</select>';
      $('#r-date').addEventListener('change', function () { if (this.value) calcTotal(); });

      // Option values come from toApiDate, which does not zero-pad (1/5/2026 -> 2026-1-5).
      if (preferredDate && /^\d{4}-\d{2}-\d{2}$/.test(preferredDate)) {
        var match = state.deliveryDates.map(toApiDate).filter(function (v) {
          var p = v.split('-');
          return p[0] + '-' + ('0' + p[1]).slice(-2) + '-' + ('0' + p[2]).slice(-2) === preferredDate;
        })[0];
        if (match) {
          $('#r-date').value = match;
          calcTotal();
        }
      }
    }).catch(function () {
      if (requestId !== state.datesRequest || val('#r-zip') !== zip) return;
      state.datesLoading = false;
      container.innerHTML = '<p style="color:#c0392b;font-size:0.9em;margin:0.4em 0">Could not check dates. Try again.</p>' +
        '<select id="r-date" required disabled><option value="">Error</option></select>';
    });
  }

  // ============================================================
  // Calculate Total
  // ============================================================

  function quoteProducts(zip) {
    return state.cartItems.map(function (item) {
      return { CODE: item.CODE, PRICE: item.PRICE, RECIPIENT: { ZIPCODE: zip } };
    });
  }

  function quoteKey() { return JSON.stringify(quoteProducts(val('#r-zip'))); }

  function updateTotalHTML(html, ready, total) {
    ['#order-totals', '#order-totals-2'].forEach(function (selector) {
      var summary = $(selector);
      if (summary) summary.innerHTML = html;
    });
    var place = $('#place-order-btn'), next = $('#continue-btn');
    if (place) {
      place.disabled = !ready;
      place.textContent = ready ? 'Place Order — $' + total.toFixed(2) : 'Place Order';
    }
    if (next) next.disabled = !ready;
  }

  function pendingTotal(message) {
    var subtotal = state.cartItems.reduce(function (sum, p) { return sum + p.PRICE; }, 0);
    updateTotalHTML(
      '<div class="tfd-order-line"><span>Subtotal</span><span>$' + subtotal.toFixed(2) + '</span></div>' +
      '<div class="tfd-order-line"><span>Delivery</span><span>$' + DELIVERY_FEE.toFixed(2) + '</span></div>' +
      '<div class="tfd-order-line"><span>Tax</span><span>' + esc(message) + '</span></div>' +
      '<div class="tfd-order-total"><span>Total</span><span>' + esc(message) + '</span></div>' +
      (message === 'Unable to calculate' ? '<button type="button" data-tfd-retry-total class="tfd-btn tfd-btn-secondary">Retry total</button>' : ''), false);
    $$('[data-tfd-retry-total]').forEach(function (retry) { retry.addEventListener('click', calcTotal); });
  }

  function invalidateQuote(message) {
    state.quoteRequest++;
    state.orderTotal = null;
    state.quoteKey = '';
    state.quotePromise = null;
    state.quoteLoading = false;
    pendingTotal(message);
  }

  function validateTotal(t) {
    function cents(amount) {
      if (typeof amount !== 'number' || !Number.isFinite(amount) || amount < 0 ||
          Math.abs(amount * 100 - Math.round(amount * 100)) > .00001) throw new Error('Invalid order amount');
      return Math.round(amount * 100);
    }
    var delivery = t.DELIVERYCHARGETOTAL != null ? t.DELIVERYCHARGETOTAL : t.FLORISTONEDELIVERYCHARGE;
    var subtotal = cents(t.SUBTOTAL), tax = cents(t.TAXTOTAL), fee = cents(delivery), total = cents(t.ORDERTOTAL);
    var cartSubtotal = state.cartItems.reduce(function (sum, item) { return sum + cents(item.PRICE); }, 0);
    var discount = t.DISCOUNT == null ? 0 : cents(t.DISCOUNT);
    if (subtotal !== cartSubtotal || total !== subtotal + fee + tax - discount) throw new Error('Order breakdown does not match the total');
    return { delivery: delivery, discount: discount / 100 };
  }

  function calcTotal() {
    var zip = val('#r-zip');
    if (!/^\d{5}$/.test(zip)) { invalidateQuote('Enter delivery ZIP'); return Promise.resolve(null); }
    var key = quoteKey();
    if (state.orderTotal && state.quoteKey === key) return Promise.resolve(state.orderTotal);
    if (state.quoteLoading && state.quoteKey === key) return state.quotePromise;
    var requestId = ++state.quoteRequest;
    state.orderTotal = null;
    state.quoteKey = key;
    state.quoteLoading = true;
    pendingTotal('Calculating…');
    state.quotePromise = apiFetch('/total', {
      params: { products: JSON.stringify(quoteProducts(zip)) },
      signal: typeof AbortSignal !== 'undefined' && AbortSignal.timeout ? AbortSignal.timeout(20000) : undefined,
    }).then(function (t) {
      if (requestId !== state.quoteRequest || quoteKey() !== key) return null;
      var breakdown = validateTotal(t);
      state.orderTotal = t;
      state.quoteLoading = false;
      var html =
        '<div class="tfd-order-line"><span>Subtotal</span><span>$' + t.SUBTOTAL.toFixed(2) + '</span></div>' +
        '<div class="tfd-order-line"><span>Delivery</span><span>$' + breakdown.delivery.toFixed(2) + '</span></div>' +
        (breakdown.discount ? '<div class="tfd-order-line"><span>Discount</span><span>−$' + breakdown.discount.toFixed(2) + '</span></div>' : '') +
        '<div class="tfd-order-line"><span>Tax</span><span>$' + t.TAXTOTAL.toFixed(2) + '</span></div>' +
        '<div class="tfd-order-total"><span>Total</span><span>$' + t.ORDERTOTAL.toFixed(2) + '</span></div>';
      updateTotalHTML(html, true, t.ORDERTOTAL);
      try { localStorage.setItem('tfd_delivery_zip', zip); } catch (e) {}
      return t;
    }).catch(function () {
      if (requestId !== state.quoteRequest || quoteKey() !== key) return null;
      state.orderTotal = null;
      state.quoteLoading = false;
      state.quotePromise = null;
      pendingTotal('Unable to calculate');
      return null;
    });
    return state.quotePromise;
  }

  // ============================================================
  // Place Order
  // ============================================================

  function placeOrder() {
    clearError();
    trackFunnel('order_attempt', cartInfo({ zip: val('#r-zip') }));

    // Validate step 2 fields
    if (!validateStep(2)) {
      showError('Please fill in all required fields.');
      trackFunnel('order_error', { detail: 'validation: required fields' });
      return;
    }

    var sameAddr = $('#same-addr').checked;

    var f = {
      cName: val('#c-name'), cEmail: val('#c-email'), cPhone: val('#c-phone'),
      cAddr: sameAddr ? val('#r-addr') : val('#c-addr'),
      cCity: sameAddr ? val('#r-city') : val('#c-city'),
      cState: sameAddr ? val('#r-state') : val('#c-state'),
      cZip: sameAddr ? val('#r-zip') : val('#c-zip'),
      rName: val('#r-name'), rPhone: val('#r-phone'),
      rInst: val('#r-inst'), rAddr2: val('#r-addr2'),
      rAddr: val('#r-addr'), rCity: val('#r-city'), rState: val('#r-state'), rZip: val('#r-zip'),
      rDate: val('#r-date'), rMsg: val('#r-message'), rInstr: val('#r-instr'),
      ccNum: val('#cc-num'), ccMonth: val('#cc-month'), ccYear: val('#cc-year'), ccCvv: val('#cc-cvv'),
    };

    // Final validation
    var missing = [];
    if (!f.cName) missing.push('Name');
    if (!f.cEmail) missing.push('Email');
    if (!f.cPhone) missing.push('Phone');
    if (!f.cAddr) missing.push('Billing Address');
    if (!f.cCity) missing.push('Billing City');
    if (!f.cState) missing.push('Billing State');
    if (!f.cZip) missing.push('Billing Zip');
    if (!f.ccNum) missing.push('Card Number');
    if (!f.ccMonth) missing.push('Exp Month');
    if (!f.ccYear) missing.push('Exp Year');
    if (!f.ccCvv) missing.push('CVV');

    if (missing.length) { showError('Please fill in: ' + missing.join(', ')); trackFunnel('order_error', { detail: 'validation: ' + missing.join(', ') }); return; }
    if (f.rPhone.replace(/\D/g, '').length < 10) { showError('Recipient phone must be at least 10 digits.'); trackFunnel('order_error', { detail: 'validation: recipient phone' }); return; }
    if (!state.orderTotal || state.quoteLoading || state.quoteKey !== quoteKey()) { showError('Please confirm your delivery ZIP and total before placing your order.'); trackFunnel('order_error', { detail: 'validation: no delivery total' }); return; }
    if (!state.authorizenet) { showError('Payment system loading. Wait a moment and try again.'); trackFunnel('order_error', { detail: 'payment system not loaded' }); return; }

    var confirmedTotal = state.orderTotal;
    var confirmedQuoteKey = state.quoteKey;
    showProcessing('Processing payment...');

    tokenize(f).then(function (token) {
      if (state.orderTotal !== confirmedTotal || quoteKey() !== confirmedQuoteKey) throw new Error('Delivery details changed. Please confirm the updated total before placing your order.');
      showProcessing('Placing order...');

      var body = {
        customer: JSON.stringify({
          name: f.cName, email: f.cEmail, phone: f.cPhone.replace(/\D/g, ''),
          address1: f.cAddr, address2: '', city: f.cCity, state: f.cState,
          country: 'US', zipcode: f.cZip, ip: '',
        }),
        products: JSON.stringify(state.cartItems.map(function (item) {
          return {
            code: item.CODE, price: item.PRICE, deliverydate: f.rDate,
            cardmessage: f.rMsg || 'Enjoy!', specialinstructions: f.rInstr,
            recipient: {
              name: f.rName, institution: f.rInst, phone: f.rPhone.replace(/\D/g, ''),
              address1: f.rAddr, address2: f.rAddr2, city: f.rCity,
              state: f.rState, country: 'US', zipcode: f.rZip,
            },
          };
        })),
        ccinfo: JSON.stringify({ AUTHORIZENET_TOKEN: token }),
        ordertotal: confirmedTotal.ORDERTOTAL,
      };

      return apiFetch('/order', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });
    }).then(function (result) {
      hideProcessing();

      // Clear cart
      if (state.cartSessionId) {
        apiFetch('/cart', { method: 'DELETE', params: { sessionid: state.cartSessionId } }).catch(function () {});
      }
      try { localStorage.removeItem('tfd_cart_session'); } catch (e) {}
      try { sessionStorage.removeItem(PREFILL_KEY); } catch (e) {}
      state.prefill = null;

      // Show confirmation
      var del = result.FLORISTONEDELIVERYCHARGE || result.DELIVERYCHARGETOTAL || 0;
      $root.innerHTML =
        '<div style="text-align:center;padding:2em 0">' +
          '<div style="width:64px;height:64px;background:#3a8f5c;color:#fff;border-radius:999px;display:flex;align-items:center;justify-content:center;margin:0 auto 1em;font-size:2em">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" width="32" height="32"><path d="M20 6L9 17l-5-5"/></svg>' +
          '</div>' +
          '<h2>Order Confirmed!</h2>' +
          '<p style="color:#666;font-size:1.1em">Order #' + result.ORDERNO + '</p>' +
          '<div style="background:#f5f5f5;border-radius:12px;padding:1.5em;text-align:left;max-width:400px;margin:1.5em auto">' +
            '<div class="tfd-order-line"><span>Subtotal</span><span>$' + result.SUBTOTAL.toFixed(2) + '</span></div>' +
            '<div class="tfd-order-line"><span>Delivery</span><span>$' + del.toFixed(2) + '</span></div>' +
            '<div class="tfd-order-line"><span>Tax</span><span>$' + (result.TAXTOTAL || 0).toFixed(2) + '</span></div>' +
            '<div class="tfd-order-total"><span>Total</span><span>$' + result.ORDERTOTAL.toFixed(2) + '</span></div>' +
          '</div>' +
          '<p>Confirmation email sent. Your flowers will be delivered on the selected date.</p>' +
          '<div style="background:#fdf2f4;border-radius:12px;padding:1.2em;max-width:400px;margin:1.5em auto;text-align:left;font-size:0.95em">' +
            '<p style="margin:0 0 0.5em;font-weight:600;color:#333">Need help with your order?</p>' +
            '<p style="margin:0;color:#555">For delivery updates, changes, or cancellations:</p>' +
            '<p style="margin:0.4em 0 0;color:#555">Phone: <a href="tel:8886108262" style="color:#d4576b">888-610-8262</a></p>' +
            '<p style="margin:0.2em 0 0;color:#555">Text: <a href="sms:5014060358" style="color:#d4576b">501-406-0358</a></p>' +
          '</div>' +
          '<a href="/" class="tfd-btn tfd-btn-primary" style="display:inline-block;margin-top:1em;text-decoration:none">Continue Shopping</a>' +
        '</div>';

      // Google Ads purchase conversion. Value = TFD's 20% Florist One commission on the arrangements.
      try {
        // Same condition the order log uses: Florist One returned an order number.
        if (typeof window.gtag === 'function' && result.ORDERNO) {
          window.gtag('event', 'conversion', {
            send_to: 'AW-18479150734/TJvICJXwpIkdEI7txetE',
            value: Math.round((result.SUBTOTAL || 0) * 20) / 100,
            currency: 'USD',
            transaction_id: String(result.ORDERNO)
          });
        }
      } catch (e) {}
    }).catch(function (err) {
      hideProcessing();
      showError(err.message || 'Order failed. Please try again.');
      trackFunnel('order_error', cartInfo({ detail: 'order: ' + ((err && err.message) || 'failed') }));
    });
  }

  // ============================================================
  // Accept.js
  // ============================================================

  function loadAcceptJS(url) {
    if (document.querySelector('script[data-tfd-ajs]')) return;
    var s = document.createElement('script');
    s.src = url;
    s.setAttribute('data-tfd-ajs', '1');
    document.head.appendChild(s);
  }

  function tokenize(f) {
    return new Promise(function (resolve, reject) {
      if (typeof Accept === 'undefined') {
        reject(new Error('Payment system not loaded. Refresh and try again.'));
        return;
      }
      Accept.dispatchData({
        authData: { clientKey: state.authorizenet.key, apiLoginID: state.authorizenet.username },
        cardData: { cardNumber: f.ccNum.replace(/\s/g, ''), month: f.ccMonth, year: f.ccYear, cardCode: f.ccCvv },
      }, function (resp) {
        if (resp.messages.resultCode === 'Error') {
          reject(new Error(resp.messages.message.map(function (m) { return m.text; }).join('; ')));
        } else {
          resolve(resp.opaqueData.dataValue);
        }
      });
    });
  }

  // ============================================================
  // UI Helpers
  // ============================================================

  function showError(msg) {
    var el = $('#tfd-checkout-error');
    if (el) {
      el.innerHTML = '<div class="tfd-error-msg">' + esc(msg) + '</div>';
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }
  function clearError() { var el = $('#tfd-checkout-error'); if (el) el.innerHTML = ''; }

  function showProcessing(msg) {
    var o = document.getElementById('tfd-proc');
    if (!o) { o = document.createElement('div'); o.id = 'tfd-proc'; document.body.appendChild(o); }
    o.className = 'tfd-processing-overlay';
    o.innerHTML = '<div class="tfd-spinner" style="width:48px;height:48px"></div><p>' + esc(msg) + '</p>';
  }
  function hideProcessing() { var o = document.getElementById('tfd-proc'); if (o) o.remove(); }

  // ============================================================
  // Init
  // ============================================================

  // ============================================================
  // Cart bridge: /pages/checkout?add=CODE[,CODE]
  // ============================================================
  // Set by the edge worker when a Shopify checkout link (agentic storefronts,
  // cart permalinks) is redirected here: the Shopify cart's variants are
  // mapped to Florist One codes so the shopper does not land on an empty
  // checkout. Runs once per tab per code list and strips the param.
  function consumeAddParam() {
    var codes = [];
    var raw = '';
    try {
      var params = new URLSearchParams(window.location.search);
      raw = params.get('add') || '';
      // Case is kept: some Florist One codes end in a lowercase letter (e.g. S5348s).
      codes = raw.split(',').map(function (c) { return c.trim(); })
        .filter(function (c) { return /^[A-Za-z0-9-]{3,24}$/.test(c); }).slice(0, 6);
      if (!codes.length) return Promise.resolve(false);

      var guardKey = 'tfd_bridge_added_' + raw;
      try {
        if (sessionStorage.getItem(guardKey)) return Promise.resolve(false);
        sessionStorage.setItem(guardKey, '1');
      } catch (e) {}

      try {
        params.delete('add');
        window.history.replaceState(null, '', window.location.pathname + (params.toString() ? '?' + params.toString() : '') + window.location.hash);
      } catch (e) {}
    } catch (e) {
      return Promise.resolve(false);
    }

    $root.innerHTML = '<p style="text-align:center;padding:2em;color:#666">Adding your flowers…</p>';

    function newSession() {
      return apiFetch('/cart', { method: 'POST' }).then(function (cart) {
        state.cartSessionId = cart.SESSIONID;
        try { localStorage.setItem('tfd_cart_session', state.cartSessionId); } catch (e) {}
      });
    }
    function addOne(code) {
      var put = function () {
        return apiFetch('/cart', { method: 'PUT', params: { sessionid: state.cartSessionId, action: 'add', productcode: code } });
      };
      // A stale session fails the add: start a fresh one and retry once.
      return put().catch(function () { return newSession().then(put); });
    }

    var start = state.cartSessionId ? Promise.resolve() : newSession();
    return start.then(function () {
      return codes.reduce(function (chain, code) {
        return chain.then(function () {
          return addOne(code).catch(function (err) { console.error('TFD: bridge add failed for ' + code, err); });
        });
      }, Promise.resolve());
    }).then(function () { return true; }).catch(function (err) {
      console.error('TFD: cart bridge failed', err);
      return false;
    });
  }

  // ============================================================
  // Prefill: /pages/checkout?add=CODE#prefill=TOKEN
  // ============================================================
  // Set by the MCP create_prefilled_checkout tool when an AI assistant passes the
  // recipient name, venue, room, card message, instructions, ZIP or date.
  // The token points at a 24-hour record on the worker (GET /prefill); the
  // details themselves never appear in the URL, and the token rides in the
  // fragment, which browsers never send to a server (so it stays out of request
  // logs, Referer headers and the tfd_landing attribution path). The token is
  // kept in sessionStorage so a reload still fills the form, and cleared after
  // the order is placed. Fields the shopper has already typed are never overwritten.
  var PREFILL_KEY = 'tfd_prefill';

  function capturePrefillToken() {
    try {
      var m = /(?:^#|&)prefill=([^&]*)/.exec(window.location.hash || '');
      if (!m) return;
      if (/^[a-f0-9]{32}$/.test(m[1])) {
        try { sessionStorage.setItem(PREFILL_KEY, m[1]); } catch (e) {}
      }
      window.history.replaceState(null, '', window.location.pathname + window.location.search);
    } catch (e) {}
  }

  function loadPrefill() {
    var token = '';
    try { token = sessionStorage.getItem(PREFILL_KEY) || ''; } catch (e) {}
    if (!/^[a-f0-9]{32}$/.test(token)) return Promise.resolve(null);
    return apiFetch('/prefill', { params: { token: token } }).then(function (data) {
      if (!data || data.error) {
        try { sessionStorage.removeItem(PREFILL_KEY); } catch (e) {}
        return null;
      }
      state.prefill = data;
      // Shoppers who land straight on checkout have no cart thumbnail cached yet.
      if (data.code && data.image && /^https:\/\//.test(data.image)) {
        state.productImages[data.code] = data.image;
        state.productImages[String(data.code).toUpperCase()] = data.image;
        try { localStorage.setItem('tfd_product_images', JSON.stringify(state.productImages)); } catch (e) {}
      }
      return data;
    }).catch(function (err) {
      console.error('TFD: prefill load failed', err);
      return null;
    });
  }

  function applyPrefill(d) {
    if (!d) return;
    function fill(sel, value) {
      var el = $(sel);
      if (el && value && !el.value) {
        el.value = String(value).slice(0, el.maxLength > 0 ? el.maxLength : 200);
        el.classList.add('tfd-valid');
      }
    }
    fill('#r-name', d.recipient_name);
    fill('#r-inst', d.venue_name);
    fill('#r-addr2', d.room_or_unit);
    fill('#r-message', d.card_message);
    fill('#r-instr', d.special_instructions);

    var zipEl = $('#r-zip');
    if (zipEl && !zipEl.value && /^\d{5}$/.test(d.zip || '')) {
      zipEl.value = d.zip;
      var st = stateFromZip(d.zip);
      if (st && $('#r-state') && !$('#r-state').value) $('#r-state').value = st;
      // Same as typing a ZIP: dates and the exact total (payment stays disabled until it is confirmed).
      autoFetchDates(d.zip, d.date);
      calcTotal();
    }
  }

  function init() {
    $root = document.getElementById('tfd-checkout');
    if (!$root) return;
    // The theme's central class has a fixed width; keep checkout on-screen.
    var container = $root.parentElement;
    if (container && container.classList.contains('central')) {
      container.style.width = '100%';
      container.style.minWidth = '0';
      container.style.boxSizing = 'border-box';
    }

    capturePrefillToken();
    // Bridged items must be in the FO cart before the cart is read and rendered,
    // and saved prefill details must be loaded before the form is drawn.
    consumeAddParam().then(loadPrefill, loadPrefill).then(startCheckout, startCheckout);
  }

  function startCheckout() {
    if (!state.cartSessionId) {
      $root.innerHTML = '<div style="text-align:center;padding:3em 1em"><h2 style="font-size:1.3em">Your cart is empty</h2><p style="color:#666;margin:0.5em 0 1em">Add some flowers before checking out.</p><a href="/" class="tfd-btn tfd-btn-primary" style="display:inline-block;text-decoration:none">Continue Shopping</a></div>';
      return;
    }

    // Load cart
    apiFetch('/cart', { params: { sessionid: state.cartSessionId } }).then(function (data) {
      state.cartItems = data.products || [];
      renderCheckout();
      if (state.cartItems.length) trackFunnel('checkout_view', cartInfo());
    }).catch(function () {
      $root.innerHTML = '<div style="text-align:center;padding:3em"><h2>Cart expired</h2><p><a href="/">Start shopping</a></p></div>';
    });

    // Pre-fetch Authorize.net key
    apiFetch('/authorizenet-key').then(function (data) {
      state.authorizenet = { username: data.USERNAME, key: data.AUTHORIZENET_KEY, url: data.AUTHORIZENET_URL };
      loadAcceptJS(data.AUTHORIZENET_URL);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }

})();
